import gql from "graphql-tag";

const getPeriodos = gql`
  query Periodos($idInstitucion: String!) {
    getPeriodsCredits(idInstitucion: $idInstitucion) {
      year
      month
      period
    }
  }
`;

const getInfoPerspectivesR = gql `
  query infoPerspectives($anio: Float!, $mes: Float!, $idInstitucion: String!) {
    getSubcalculation(anio: $anio, mes: $mes, idInstitucion: $idInstitucion) {
      tipoCredito {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      genero {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      montoOtorgado {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      plazoCredito {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      nivelAprobacion {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      garantia {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      sucursal {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      sector {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      zona {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      producto {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      categoriaMorosidad {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      metodologia {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      edad {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      tipoInteres {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      departamento {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      etnia {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      estadoCivil {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      nivelEducativo {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      tasaInteres {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      vinculados {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
      fuentesPago {
        name
        creditos
        saldo
        creditosMora
        saldoMora
        limits {
          min
          max
        }
      }
    }
  }
`;

const getMayoresDeudores = gql `
query GetMayoresDeudores($anio: Float!, $mes: Float!, $idInstitucion: String!) {
  getMayoresDeudores(anio: $anio, mes: $mes, idInstitucion: $idInstitucion) {
    socios {
      idSocio
      saldo
      creditos
      creditosVencidos
      saldoVencido
      creditosVigentes
      saldoVigente
    }
    cartera {
      idSocio
      saldo
      creditos
      creditosVencidos
      saldoVencido
      creditosVigentes
      saldoVigente
    }
    limites {
      min
      max
      name
    }
  }
}
`;
const getGini = gql`
query Query($anio: Float!, $mes: Float!, $idInstitucion: String!) {
  getGini(anio: $anio, mes: $mes, idInstitucion: $idInstitucion)
}
`;
const getCoberturaRiesgos = gql`
query ObtenerCobertura($idInstitucion: String!, $periodo: PeriodoInput!) {
  obtenerCobertura(idInstitucion: $idInstitucion, periodo: $periodo) {
    estatus
    numero
    saldo
    montoConstituido
  }
}
`;

export { getPeriodos, getInfoPerspectivesR, getMayoresDeudores, getCoberturaRiesgos, getGini }